function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

document.addEventListener("DOMContentLoaded", () => {
  const discountCode = getCookie('discount_code');
  if (discountCode) document.body.classList.add('has-discount-code');
});
